import { useState, useRef, useContext } from 'react'
import { Popper, Grow, ClickAwayListener, Paper, MenuList, MenuItem } from '@material-ui/core'
import { ValidatorContext } from 'containers/Examination/ExaminationContext'
import { saveQuestion as uploadQuestion } from 'containers/Examination/ExaminationService'
import { ExamContext } from 'containers/Examination/ExaminationContext'
import NewItemModal from './NewItem/NewItemModal'

const AddQuestion = (props) => {
  const { onQuestionCreated } = props
  const anchorRef = useRef(null)
  const examContext = useContext(ExamContext)

  const [openPopper, setOpenPopper] = useState(false)

  const closePopper = () => {
    setOpenPopper(false)
  }

  const openAddQuestionModal = (e) => {
    e.preventDefault()
    setOpenPopper(true)
  }

  const [newItemModalState, setNewItemModalState] = useState('closed')

  const openCreateQuestionDialog = (type) => {
    setNewItemModalState(type)
    closePopper()
  }

  const modalClosed = () => {
    setNewItemModalState('closed')
    setValidationError({})
  }

  const [question, setQuestion] = useState({})
  const [validationError, setValidationError] = useState({})

  const saveQuestion = async () => {
    setValidationError({})

    const response = await uploadQuestion(examContext.exam.id, question)

    if (!response.success && response.error_type === "failed_validation") {
      setValidationError(response.errors)
      return
    }

    modalClosed()
    onQuestionCreated()
  }

  return (
    <>
      <a href="/" onClick={openAddQuestionModal} ref={anchorRef}>
        <i className="fa fa-plus-circle"></i>&nbsp;New Question
      </a>
      <Popper open={openPopper} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
          >
            <Paper>
              <ClickAwayListener onClickAway={closePopper}>
                <MenuList autoFocusItem={openPopper} id="menu-list-grow">
                  <MenuItem onClick={() => openCreateQuestionDialog('MULTIPLE_CHOICES')}>Multiple Choices</MenuItem>
                  <MenuItem onClick={() => openCreateQuestionDialog('SHORT_ANSWER')}>Short text answer</MenuItem>
                  <MenuItem onClick={() => openCreateQuestionDialog('LONG_ANSWER')}>Essay / Long Explanation</MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>

      <ValidatorContext.Provider value={{validationError, question}}>
        <ExamContext.Provider value={{setQuestion, saveQuestion}}>
          <NewItemModal modalState={newItemModalState} onClose={modalClosed} />
        </ExamContext.Provider>
      </ValidatorContext.Provider>
    </>
  )
}

export default AddQuestion